import React from "react";

const IPlane = ({ color = "#fff", width = "14", height = "14", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M11.9335 1.4109C12.128 1.37432 12.2995 1.4587 12.4052 1.59433C12.5412 1.70001 12.6259 1.8718 12.5892 2.06658L12.563 2.15886L8.80324 12.0955C8.5815 12.6815 7.77249 12.7332 7.47764 12.1803L5.796 9.02841L8.57879 6.24618C8.80654 6.01838 8.80655 5.64911 8.57879 5.42131C8.351 5.19353 7.98173 5.19356 7.75392 5.42131L4.9717 8.20297L1.81976 6.52247C1.26691 6.22761 1.31863 5.4186 1.90464 5.19687L11.8412 1.4371L11.9335 1.4109Z"
        fill={color}
      />
    </svg>
  );
};

export default IPlane;
